import { radio, radio2 } from "assets/icons";
import React from "react";
import styled from "styled-components";
import Skeleton2 from "./Skeleton2";

const RadioFilter = ({
  checked,
  setChecked,
  setChecked2,
  banks,
  onClick,
  onClick2,
  loading,
}) => {
  return (
    <Box onClick={onClick}>
      <div className="options">
        {loading ? (
          <Skeleton2 />
        ) : (
          banks?.map((item) => {
            return (
              <div
                onClick={() => {
                  if (checked === item?.code) {
                    setChecked("");
                    setChecked2("All");
                  } else {
                    setChecked(item?.code);
                    setChecked2(item?.name || item?.code);
                  }
                }}
                className="option"
              >
                <img src={item?.code === checked ? radio : radio2} alt="" />
                <div>{item?.name || item?.code}</div>
              </div>
            );
          })
        )}
      </div>
      <div className="bottom">
        <Button disabled={!checked} onClick={onClick2}>
          Apply
        </Button>
      </div>
    </Box>
  );
};

export default RadioFilter;

const Box = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  border-radius: 10px;
  border: 1px solid #d3d3d3;
  width: 300px;
  background-color: white;
  z-index: 120;
  font-size: 14px;
  .options {
    padding: 20px;
    height: 300px;
    overflow: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
  .option {
    display: flex;
    margin-bottom: 20px;
    font-weight: 300;
    img {
      margin-right: 16px;
    }
  }

  .option:last-child {
    margin-bottom: 0;
  }
  .bottom {
    border-top: 1px solid #ebeefa;
    padding: 20px;
    padding-top: 10px;
  }
`;
const Button = styled.button`
  width: 100%;
  background-color: #ff993a;
  border: none;
  color: white;
  border-radius: 8px;
  padding: 10px 0;
  font-size: 12px;
  cursor: pointer;
  display: grid;
  place-items: center;
`;
/* <TransactionModal setOptValue={setOptValue} title="Filter By" options={[{name: 'Approved Status', value: 'approved'} ]} optionLabel="name" optionValue="value" /> */
/* <TransactionModal title="Filter By">
       <p>Approved Status</p>
       <p>Date Range</p>
       <p> Direction</p>
       <p> Reversible</p>
      </TransactionModal> */
//     const [optValue, setOptValue] = useState()
// console.log(optValue)
